/*!
 * Interpolate text/node attributes {{ }} 🥊  @tko/provider.mustache@4.0.0-alpha8
 * (c) The Knockout.js Team - https://tko.io
 * License: MIT (http://www.opensource.org/licenses/mit-license.php)
 */

import { Parser } from '@tko/utils.parser';
import { unwrap } from '@tko/observable';
import { Provider } from '@tko/provider';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = Object.setPrototypeOf ||
    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

var INNER_EXPRESSION = /^([\s\S]*)}}([\s\S]*?)\{\{([\s\S]*)$/;
var OUTER_EXPRESSION = /^([\s\S]*?)\{\{([\s\S]*)}}([\s\S]*)$/;
var BINDING_EXPRESSION = /^([^,"'{}()/:[\]\s]+)\s+([^\s:].*)/;
var Interpolated = /** @class */ (function () {
    function Interpolated(text) {
        this.text = text;
    }
    Interpolated.prototype.trim = function (string) {
        return string === null ? '' : string.trim();
    };
    return Interpolated;
}());
var Expression = /** @class */ (function (_super) {
    __extends(Expression, _super);
    function Expression() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Expression.prototype.asAttr = function (context, globals, node) {
        return new Parser().parseExpression(this.text, context, globals, node)();
    };
    Expression.prototype.textNodeReplacement = function (textNode) {
        var text, ownerDocument, firstChar, lastChar, closeComment, binding, matches;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    text = this.trim(this.text);
                    ownerDocument = textNode ? textNode.ownerDocument : document;
                    firstChar = text[0];
                    lastChar = text[text.length - 1];
                    closeComment = true;
                    if (firstChar === '#') {
                        if (lastChar === '/') {
                            binding = text.slice(1, -1);
                        }
                        else {
                            binding = text.slice(1);
                            closeComment = false;
                        }
                        matches = binding.match(BINDING_EXPRESSION);
                        if (matches) {
                            binding = matches[1] + ':' + matches[2];
                        }
                    }
                    else if (firstChar === '/') ;
                    else if (firstChar === '{' && lastChar === '}') {
                        binding = 'html:' + this.trim(text.slice(1, -1));
                    }
                    else {
                        binding = 'text:' + this.trim(text);
                    }
                    if (!binding) return [3 /*break*/, 2];
                    return [4 /*yield*/, ownerDocument.createComment('ko ' + binding)];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    if (!closeComment) return [3 /*break*/, 4];
                    return [4 /*yield*/, ownerDocument.createComment('/ko')];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    };
    return Expression;
}(Interpolated));
var Text = /** @class */ (function (_super) {
    __extends(Text, _super);
    function Text() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Text.prototype.asAttr = function () { return this.text; };
    Text.prototype.textNodeReplacement = function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, document.createTextNode(this.text.replace(/"/g, '\\"'))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    };
    return Text;
}(Interpolated));
/**
 *          Interpolation Parsing
 */
function innerParse(text) {
    var innerMatch, _a, pre, inner, post;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                innerMatch = text.match(INNER_EXPRESSION);
                if (!innerMatch) return [3 /*break*/, 4];
                _a = __read(innerMatch.slice(1), 3), pre = _a[0], inner = _a[1], post = _a[2];
                return [5 /*yield**/, __values(innerParse(pre))];
            case 1:
                _b.sent();
                return [4 /*yield*/, new Text(inner)];
            case 2:
                _b.sent();
                return [4 /*yield*/, new Expression(post)];
            case 3:
                _b.sent();
                return [3 /*break*/, 6];
            case 4: return [4 /*yield*/, new Expression(text)];
            case 5:
                _b.sent();
                _b.label = 6;
            case 6: return [2 /*return*/];
        }
    });
}
function parseOuterMatch(outerMatch) {
    var _a, pre, inner, post;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!outerMatch) {
                    return [2 /*return*/];
                }
                _a = __read(outerMatch.slice(1), 3), pre = _a[0], inner = _a[1], post = _a[2];
                return [4 /*yield*/, new Text(pre)];
            case 1:
                _b.sent();
                return [5 /*yield**/, __values(innerParse(inner))];
            case 2:
                _b.sent();
                return [4 /*yield*/, new Text(post)];
            case 3:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
function parseInterpolation(text) {
    var e_1, _a, _b, _c, textOrExpr, e_1_1;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _d.trys.push([0, 5, 6, 7]);
                _b = __values(parseOuterMatch(text.match(OUTER_EXPRESSION))), _c = _b.next();
                _d.label = 1;
            case 1:
                if (!!_c.done) return [3 /*break*/, 4];
                textOrExpr = _c.value;
                if (!textOrExpr.text) return [3 /*break*/, 3];
                return [4 /*yield*/, textOrExpr];
            case 2:
                _d.sent();
                _d.label = 3;
            case 3:
                _c = _b.next();
                return [3 /*break*/, 1];
            case 4: return [3 /*break*/, 7];
            case 5:
                e_1_1 = _d.sent();
                e_1 = { error: e_1_1 };
                return [3 /*break*/, 7];
            case 6:
                try {
                    if (_c && !_c.done && (_a = _b["return"])) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
                return [7 /*endfinally*/];
            case 7: return [2 /*return*/];
        }
    });
}

/**
 * These are bindings that are mapped specific attributes, such as
 * two-way communication (value/checked) or which have anti-collision
 * properties (css).
 */
var DEFAULT_ATTRIBUTE_BINDING_MAP = {
    value: 'value',
    checked: 'checked',
    "class": 'css'
};
/**
 *  Interpret {{ }} inside DOM attributes e.g. <div class='{{ classes }}'>
 */
var AttributeMustacheProvider = /** @class */ (function (_super) {
    __extends(AttributeMustacheProvider, _super);
    function AttributeMustacheProvider(params) {
        if (params === void 0) { params = {}; }
        var _this = _super.call(this, params) || this;
        _this.ATTRIBUTES_TO_SKIP = new Set(params.attributesToSkip || ['data-bind']);
        _this.ATTRIBUTES_BINDING_MAP = params.attributesBindingMap || DEFAULT_ATTRIBUTE_BINDING_MAP;
        return _this;
    }
    Object.defineProperty(AttributeMustacheProvider.prototype, "FOR_NODE_TYPES", {
        get: function () { return [1]; } // document.ELEMENT_NODE
        ,
        enumerable: true,
        configurable: true
    });
    AttributeMustacheProvider.prototype.attributesToInterpolate = function (attributes) {
        var e_1, _a, _b, _c, attr, e_1_1;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 5, 6, 7]);
                    _b = __values(Array.from(attributes)), _c = _b.next();
                    _d.label = 1;
                case 1:
                    if (!!_c.done) return [3 /*break*/, 4];
                    attr = _c.value;
                    if (this.ATTRIBUTES_TO_SKIP.has(attr.name)) {
                        return [3 /*break*/, 3];
                    }
                    if (!(attr.specified && attr.value.includes('{{'))) return [3 /*break*/, 3];
                    return [4 /*yield*/, attr];
                case 2:
                    _d.sent();
                    _d.label = 3;
                case 3:
                    _c = _b.next();
                    return [3 /*break*/, 1];
                case 4: return [3 /*break*/, 7];
                case 5:
                    e_1_1 = _d.sent();
                    e_1 = { error: e_1_1 };
                    return [3 /*break*/, 7];
                case 6:
                    try {
                        if (_c && !_c.done && (_a = _b["return"])) _a.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                    return [7 /*endfinally*/];
                case 7: return [2 /*return*/];
            }
        });
    };
    AttributeMustacheProvider.prototype.nodeHasBindings = function (node) {
        return !this.attributesToInterpolate(node.attributes).next().done;
    };
    AttributeMustacheProvider.prototype.partsTogether = function (parts, context, node) {
        var _this = this;
        var valueToWrite = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            valueToWrite[_i - 3] = arguments[_i];
        }
        if (parts.length > 1) {
            return parts
                .map(function (p) { return unwrap(p.asAttr(context, _this.globals, node)); }).join('');
        }
        // It may be a writeable observable e.g. value="{{ value }}".
        var part = parts[0].asAttr(context, this.globals);
        if (valueToWrite.length) {
            part(valueToWrite[0]);
        }
        return part;
    };
    AttributeMustacheProvider.prototype.attributeBinding = function (name, parts) {
        return [name, parts];
    };
    AttributeMustacheProvider.prototype.bindingParts = function (node, context) {
        var e_2, _a, _b, _c, attr, parts, e_2_1;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 5, 6, 7]);
                    _b = __values(this.attributesToInterpolate(node.attributes)), _c = _b.next();
                    _d.label = 1;
                case 1:
                    if (!!_c.done) return [3 /*break*/, 4];
                    attr = _c.value;
                    parts = Array.from(parseInterpolation(attr.value));
                    if (!parts.length) return [3 /*break*/, 3];
                    return [4 /*yield*/, this.attributeBinding(attr.name, parts)];
                case 2:
                    _d.sent();
                    _d.label = 3;
                case 3:
                    _c = _b.next();
                    return [3 /*break*/, 1];
                case 4: return [3 /*break*/, 7];
                case 5:
                    e_2_1 = _d.sent();
                    e_2 = { error: e_2_1 };
                    return [3 /*break*/, 7];
                case 6:
                    try {
                        if (_c && !_c.done && (_a = _b["return"])) _a.call(_b);
                    }
                    finally { if (e_2) throw e_2.error; }
                    return [7 /*endfinally*/];
                case 7: return [2 /*return*/];
            }
        });
    };
    AttributeMustacheProvider.prototype.getPossibleDirectBinding = function (attrName) {
        var bindingName = this.ATTRIBUTES_BINDING_MAP[attrName];
        return bindingName && this.bindingHandlers.get(attrName);
    };
    AttributeMustacheProvider.prototype.bindingObjects = function (node, context) {
        var e_3, _a, _loop_1, this_1, _b, _c, _d, attrName, parts, e_3_1;
        var _this = this;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _loop_1 = function (attrName, parts) {
                        var _a, bindingForAttribute, handler, accessorFn;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    bindingForAttribute = this_1.getPossibleDirectBinding(attrName);
                                    handler = bindingForAttribute ? attrName : "attr." + attrName;
                                    accessorFn = bindingForAttribute
                                        ? function () {
                                            var v = [];
                                            for (var _i = 0; _i < arguments.length; _i++) {
                                                v[_i] = arguments[_i];
                                            }
                                            return _this.partsTogether.apply(_this, __spread([parts, context, node], v));
                                        }
                                        : function () {
                                            var v = [];
                                            for (var _i = 0; _i < arguments.length; _i++) {
                                                v[_i] = arguments[_i];
                                            }
                                            var _a;
                                            return (_a = {}, _a[attrName] = _this.partsTogether.apply(_this, __spread([parts, context, node], v)), _a);
                                        };
                                    node.removeAttribute(attrName);
                                    return [4 /*yield*/, (_a = {}, _a[handler] = accessorFn, _a)];
                                case 1:
                                    _b.sent();
                                    return [2 /*return*/];
                            }
                        });
                    };
                    this_1 = this;
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 6, 7, 8]);
                    _b = __values(this.bindingParts(node, context)), _c = _b.next();
                    _e.label = 2;
                case 2:
                    if (!!_c.done) return [3 /*break*/, 5];
                    _d = __read(_c.value, 2), attrName = _d[0], parts = _d[1];
                    return [5 /*yield**/, _loop_1(attrName, parts)];
                case 3:
                    _e.sent();
                    _e.label = 4;
                case 4:
                    _c = _b.next();
                    return [3 /*break*/, 2];
                case 5: return [3 /*break*/, 8];
                case 6:
                    e_3_1 = _e.sent();
                    e_3 = { error: e_3_1 };
                    return [3 /*break*/, 8];
                case 7:
                    try {
                        if (_c && !_c.done && (_a = _b["return"])) _a.call(_b);
                    }
                    finally { if (e_3) throw e_3.error; }
                    return [7 /*endfinally*/];
                case 8: return [2 /*return*/];
            }
        });
    };
    AttributeMustacheProvider.prototype.getBindingAccessors = function (node, context) {
        return Object.assign.apply(Object, __spread([{}], this.bindingObjects(node, context)));
    };
    return AttributeMustacheProvider;
}(Provider));

/**
 * Interpret {{ }}, {{{ }}}, {{# /}}, and {{# }} ... {{/ }} inside text nodes.
 *
 * This binding must come before the VirtualProvider.
 */
var TextMustacheProvider = /** @class */ (function (_super) {
    __extends(TextMustacheProvider, _super);
    function TextMustacheProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(TextMustacheProvider.prototype, "FOR_NODE_TYPES", {
        get: function () { return [3]; } // document.TEXT_NODE
        ,
        enumerable: true,
        configurable: true
    });
    TextMustacheProvider.prototype.textToNodes = function (textNode) {
        var e_1, _a, parent, isTextarea, hasStash, _b, _c, part, e_1_1;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    parent = textNode.parentNode;
                    isTextarea = parent && parent.nodeName === 'TEXTAREA';
                    hasStash = textNode.nodeValue && textNode.nodeValue.includes('{{');
                    if (!hasStash || isTextarea) {
                        return [2 /*return*/];
                    }
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 6, 7, 8]);
                    _b = __values(parseInterpolation(textNode.nodeValue)), _c = _b.next();
                    _d.label = 2;
                case 2:
                    if (!!_c.done) return [3 /*break*/, 5];
                    part = _c.value;
                    return [5 /*yield**/, __values(part.textNodeReplacement(textNode))];
                case 3:
                    _d.sent();
                    _d.label = 4;
                case 4:
                    _c = _b.next();
                    return [3 /*break*/, 2];
                case 5: return [3 /*break*/, 8];
                case 6:
                    e_1_1 = _d.sent();
                    e_1 = { error: e_1_1 };
                    return [3 /*break*/, 8];
                case 7:
                    try {
                        if (_c && !_c.done && (_a = _b["return"])) _a.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                    return [7 /*endfinally*/];
                case 8: return [2 /*return*/];
            }
        });
    };
    TextMustacheProvider.prototype.textInterpolation = function (textNode) {
        var newNodes = Array.from(this.textToNodes(textNode));
        if (newNodes.length === 0) {
            return;
        }
        if (textNode.parentNode) {
            var parent_1 = textNode.parentNode;
            var n = newNodes.length;
            for (var i = 0; i < n; ++i) {
                parent_1.insertBefore(newNodes[i], textNode);
            }
            parent_1.removeChild(textNode);
        }
        return newNodes;
    };
    /**
     * We convert as follows:
     *
     *   {{# ... }} into <!-- ko ... -->
     *   {{/ ... }} into <!-- /ko -->
     *   {{# ... /}} into <!-- ko ... --><!-- /ko -->
     *   {{ ... }} into <!-- ko text: ... --><!-- /ko -->
     *   {{{ ... }}} into <!-- ko html: ... --><!-- /ko -->
     *
     * VirtualProvider can then pick up and do the actual binding.
     */
    TextMustacheProvider.prototype.preprocessNode = function (node) {
        return this.textInterpolation(node);
    };
    return TextMustacheProvider;
}(Provider));

export { AttributeMustacheProvider, TextMustacheProvider, parseInterpolation };
//# sourceMappingURL=provider.mustache.js.map
